module.exports = __webpack_public_path__ + "img/IS581008-0150.b9ec3ca6.png";